export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8733.2264d932.jpg";